<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      :class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'SYSTEM',
          'UF_NAME'
        )
      }"
    >
      <textarea
        @keyup="$parent.$parent.removeError('PROJECTS', 'SYSTEM', 'UF_NAME')"
        class="i-main-style t-dop-style i-wid-50"
        v-model="$parent.project.UF_NAME"
        :disabled="
          $parent.$parent.projectDisabled ||
            $parent.project.UF_IS_NOT_EDIT_NAME === 1
        "
        maxlength="200"
        :placeholder="getPlacholder()"
      ></textarea>
      <div class="error-text">
        {{ $parent.$parent.checkErrorText("PROJECTS", "SYSTEM", "UF_NAME") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_name",
  methods: {
    getPlacholder() {
      if (
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) === "working" ||
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) === "working_rfrp"
      ) {
        return "Рекомендуется в названии проекта использовать слова «Модернизация производства/Увеличение объемов производства». Выделить содержательную техническую составляющую, отличающую проект от аналогичных. Предельное число символов – 200";
      } else {
        return "Рекомендуется в названии проекта использовать слова «Создание/Организация производства/Модернизация производства/Производство». Выделить содержательную техническую составляющую, отличающую проект от аналогичных. Предельное число символов – 200";
      }
    }
  }
};
</script>

<style scoped></style>
